<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0" >{{$t('news.page_title')}}</h1>
    </template>

    <template v-slot:leftPanel>
      <TocWidget :toc="contentswdgt" />
    </template>

    <template v-slot:mainPanel>
      
      <v-alert text dense type="error" v-show="$i18n.locale!=='en'" class="mb-8">
        {{$t('news.translation')}}
      </v-alert>

      <!--Background-->
      <v-divider class="mb-2"></v-divider>
      <v-row id="itfbg" no-gutters class="mb-12">
        <v-col class="pa-0">
          <h2 class="text-h2 liiblack--text mb-4">{{$t('news.t_background')}}</h2>
          <p>{{$t('news.bg[0]')}}</p>
        </v-col>
      </v-row>


      <!--Search-->
      <p>{{$t('news.bg[1]')}}</p>
      <v-divider class="mb-2"></v-divider>
      <v-row id="search" no-gutters class="mb-12">
        <v-col>
          <h2 class="text-h2 liiblack--text mb-4">{{$t('news.t_feature')}} 1: {{$t('news.t_newsearch')}}</h2>
          <p class="mb-2" v-html="$t('news.srch_dec')"></p>
          <v-alert 
            dense text
            type="warning"
            class="mt-4 mb-6"
            icon="mdi-lightbulb-outline"
          >
            {{$t('news.srch_warn[0]')}}
            <li>{{$t('news.srch_warn[1]')}}</li>
            <li>{{$t('news.srch_warn[2]')}}</li>
          </v-alert>

          <!--F1-legis-->
          <div class="mb-8" id="search_legis" >
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.srch_f1')}}</h3>
            <p>{{$t('news.srch_f1_desc')}}</p>
            
            <v-row no-gutters class="my-5">
              <v-col cols="12" sm="8" class="lightgrey pa-0">
                 <video autoplay loop muted playsinline class="pa-0 news-videobox" width="100%"
                  title="Click on the legislation suggested to go to its TOC directly" >
                  <source src="../assets/nf_legis.webm"  type="video/webm" >
                  <source src="../assets/nf_legis.mp4"  type="video/mp4" >
                  {{$t('tour.videoerror')}}
                </video>
              </v-col>
              <v-col cols="12" sm="4" class="liiblack pa-4 pa-lg-6"> 
                <v-btn class="primary" href="https://www.hklii.hk/search?q=copyright%20ordinance&d=0" target="_blank">
                  {{$t('news.visitsample')}} 
                  <v-icon small class="ml-2">mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!--F2 entity-->
          <div class="mb-8" id="search_entity">
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.srch_f2')}}</h3>
            <p class="mb-2">{{$t('news.srch_f2_desc[0]')}}</p>
            <ul class="mb-2">
              <li>{{$t('news.srch_f2_cond[0]')}}</li>
              <li>{{$t('news.srch_f2_cond[1]')}}</li>
              <li>{{$t('news.srch_f2_cond[2]')}}</li>
              <li>{{$t('news.srch_f2_cond[3]')}}</li>
            </ul>
            <v-row no-gutters class="my-6" >
              <v-col cols="12" sm="8" class="lightgrey">
                <video autoplay loop muted playsinline class="pa-0 news-videobox" width="100%"
                  title="Enabling and disabling inexact match for entity search">
                  <source src="../assets/nf_entity.webm"  type="video/webm" >
                  <source src="../assets/nf_entity.mp4"  type="video/mp4" >
                  {{$t('tour.videoerror')}}
                </video>
              </v-col>
              <v-col cols="12" sm="4" class="liiblack pa-4 pa-lg-6"> 
                <v-btn class="primary" href="https://www.hklii.hk/search?q=chan%20tai%20man&d=0" target="_blank">
                  {{$t('news.visitsample')}} 
                  <v-icon small class="ml-2">mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <p>{{$t('news.srch_f2_desc[1]')}}</p>
          </div>
       
          <!--F3-keyword-->
          <div class="mb-8"  id="search_keyword">
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.srch_f3')}}</h3>
             <p class="mb-2">{{$t('news.srch_f3_desc[0]')}}</p>
             <p class="mb-2">{{$t('news.srch_f3_desc[1]')}}</p>
              <v-row no-gutters class="my-5" >
              <v-col cols="12" sm="8" class="lightgrey">
                <video autoplay loop muted playsinline class="pa-0 news-videobox" width="100%"
                  title="Tutorial on using multiple suggested legal concept keyword to refine search">
                  <source src="../assets/nf_keywords.webm"  type="video/webm" >
                  <source src="../assets/nf_keywords.mp4"  type="video/mp4" >
                  {{$t('tour.videoerror')}}
                </video>
              </v-col>
              <v-col cols="12" sm="4" class="liiblack pa-4 pa-lg-6"> 
                <v-btn class="primary" href="https://www.hklii.hk/search?q=winding%20up" target="_blank">
                  {{$t('news.visitsample')}} <v-icon small class="ml-2">mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </v-col>
      </v-row>

      <!--Info box-->
      <v-divider class="mb-2"></v-divider>
      <v-row id="infobox" no-gutters class="mb-12">
        <v-col>
          <h2 class="text-h2 liiblack--text mb-4">{{$t('news.t_feature')}} 2: {{$t('news.t_infobox')}}</h2>

          <div class="mb-6">
            <p v-html="$t('news.infob_f1_desc[0]')"></p>
          </div>

          <v-alert 
            dense text
            type="warning"
            class="mt-0 mb-2"
            icon="mdi-lightbulb-outline"
          >
           <p class="mb-0" v-html="$t('news.infob_f1_desc[1]')"></p>
          </v-alert>

          <v-alert 
            dense text
            type="warning"
            class="mt-2 mb-6"
            icon="mdi-lightbulb-outline"
          >
            {{$t('news.infob_f1_desc[2]')}}
          </v-alert>
          
          <v-row no-gutters class="my-5">
            <v-col cols="12"  sm="5" md="6"  lg="7"  class="lightgrey pa-0">
               <v-img
                contain
                :src="require('../assets/nf_caseinfo.png')"
                max-width="100%"
                alt="Case Info box is located at the left column of judgments"
                style="border: 1px solid var(--v-liiblack-base);"
              />
            </v-col>
            <v-col cols="12" sm="7" md="6"  lg="5" class="liiblack pa-4 pa-lg-6"> 
              <v-btn class="primary mb-3 mr-2" :to="{name:'case', params: {lang: 'en', abbr:'hkdc', year: '2010', num:'1098' }, target: '_blank'}">
                Drug Trafficking Sample <v-icon small class="ml-2">mdi-open-in-new</v-icon>
              </v-btn>
              <v-btn class="primary mb-3 mr-2" :to="{name:'case', params: {lang: 'en', abbr:'hkdc', year: '2009', num:'89' }, target: '_blank'}"> 
                Personal Injuries Sample <v-icon small class="ml-2">mdi-open-in-new</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>

      <!--Tag-->
      <v-divider class="mb-2"></v-divider>
      <v-row id="tagging" no-gutters class="mb-12">
        <v-col>
          <h2 class="text-h2 liiblack--text mb-4">{{$t('news.t_feature')}} 3: {{$t('news.t_tagging')}}</h2>
          <p class="mb-2" v-html="$t('news.tag_desc')"> </p>

          <v-alert 
            dense text
            type="warning"
            class="mt-4 mb-6"
            icon="mdi-lightbulb-outline"
          >
            {{$t('news.pi_warn')}}
          </v-alert>
          
          <div class="mb-8">
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.tag_f1')}}</h3>
            <p class="mb-2">{{$t('news.tag_f1_desc[0]')}}</p>
            <p class="mb-2" v-html="$t('news.tag_f1_desc[1]')" ></p>
          </div>
          
          <div class="mb-8">
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.tag_f2')}}</h3>
            <p class="mb-2">{{$t('news.tag_f2_desc[0]')}}</p>
            <p class="mb-2">{{$t('news.tag_f2_desc[1]')}}</p>
          </div>

          <v-row no-gutters class="my-5">
            <v-col cols="12" sm="8" class="lightgrey pa-0">
              <video autoplay loop muted playsinline class="pa-0 news-videobox" width="100%" 
                title="Demonstration of toggling between tree view and compact view, and using tags to conduct similar judgment search" >
                <source src="../assets/nf_tagging.webm"  type="video/webm" >
                <source src="../assets/nf_tagging.mp4"  type="video/mp4" >
                {{$t('tour.videoerror')}}
              </video>
            </v-col>
            <v-col cols="12" sm="4" class="liiblack pa-4 pa-lg-6"> 
              <v-btn class="primary" :to="{name:'case', params: {lang: 'en', abbr:'hkdc', year: '2007', num:'422' }, target: '_blank'}" >
                {{$t('news.visitsample')}} <v-icon small class="ml-2">mdi-open-in-new</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>

      <!--Summary-->
      <v-divider class="mb-2"></v-divider>
      <v-row id="casesummary" no-gutters class="mb-12">
        <v-col>
          <h2 class="text-h2 liiblack--text mb-4">{{$t('news.t_feature')}} 4: {{$t('news.t_casesummary')}}</h2>
          <p class="mb-2" v-html="$t('news.smry_desc[0]')"></p>
          <p class="mb-2" v-html="$t('news.smry_desc[1]')" ></p>
          <v-row no-gutters class="my-5" >
              <v-col cols="12" sm="8" class="lightgrey">
                <video autoplay loop muted playsinline class="pa-0 news-videobox" width="100%"
                 title="Accessing Case Summary via left sidebar of judgments" >
                  <source src="../assets/nf_summary.webm"  type="video/webm" >
                  <source src="../assets/nf_summary.mp4"  type="video/mp4" >
                  {{$t('tour.videoerror')}}
                </video>
              </v-col>
              <v-col cols="12" sm="4" class="liiblack pa-4 pa-lg-6"> 
                <v-btn class="primary" href="https://ai.hklii.hk/case-summary/?nc=%5B2007%5D%20HKDC%2032&type=1&para=true&topN=5&query=cosmetic%20surgery" target="_blank">
                  {{$t('news.visitsample')}} <v-icon small class="ml-2">mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
          </v-row>

          <v-alert 
            dense text
            type="warning"
            class="mt-4 mb-8"
            icon="mdi-lightbulb-outline"
          >
            {{$t('news.pi_warn')}}
          </v-alert>
          
          <div class="mb-8">
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.smry_f1')}}</h3>
            <p class="mb-2" v-html="$t('news.smry_f1_desc[0]')"></p>
            <p class="mb-2">{{$t('news.smry_f1_desc[1]')}}</p>
          </div>

          <div class="mb-8">
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.smry_f2')}}</h3>
            <p class="mb-2">{{$t('news.smry_f2_desc[0]')}}</p>
            <p class="mb-2">{{$t('news.smry_f2_desc[1]')}}</p>
          </div>

          <div class="mb-8">
            <h3 class="text-h3 navlink--text mb-2">{{$t('news.smry_f3')}}</h3>
            <p class="mb-2">{{$t('news.smry_f3_desc[0]')}}</p>
            <li v-html="$t('news.smry_f3_desc[1]')"></li>
            <li v-html="$t('news.smry_f3_desc[2]')"></li>
            <li class="mb-4" v-html="$t('news.smry_f3_desc[3]')"></li>
            <p class="mb-2">{{$t('news.smry_f3_desc[4]')}}</p>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-2"></v-divider>
      <v-row  no-gutters class="mb-12">
        <v-col>
        <p class="body-2 pt-1">{{$t('news.its')}}</p>
      </v-col>
      </v-row>
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import TocWidget from '@/components/TocWidget'
  export default {
    name: 'NewsRelease',
    components: {
      ThreeColumn,
      TocWidget
    },
    data(){
      return {}
    },
    /*watch: {
      '$i18n.locale': function(){
        window.document.title = `${this.$i18n.t('news.page_title')} | HKLII`
      }
    },*/
    computed:{
      contentswdgt(){
        return [
          {'title':this.$i18n.t('news.t_background'), id:'itfbg'},
          {'title':this.$i18n.t('news.t_newsearch'), id:'search'},
          {'title':this.$i18n.t('news.t_infobox'), id:'infobox'},
          {'title':this.$i18n.t('news.t_tagging'), id:'tagging'},
          {'title':this.$i18n.t('news.t_casesummary'), id:'casesummary'},
        ]
      },
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('news.page_title'), disabled: true}
        ]
      }
    },
    /*mounted(){
      window.document.title = `${this.$i18n.t('news.page_title')} | HKLII`
    },*/
    metaInfo(){
      return{
        title: this.$i18n.t('news.page_title'),
      }
    },
  }
</script>
<style scoped lang="scss">
  @import '@/sass/_typography.scss';
  
  p ::v-deep a {
    @include link-no-underline;
  }
  .news-videobox {
    display: table;
    border: 1px solid var(--v-liiblack-base);
  }
</style>
